"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Effect_DropTheHammer_OnHammerDamageEventHandlerScript = void 0;
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
let Effect_DropTheHammer_OnHammerDamageEventHandlerScript = class Effect_DropTheHammer_OnHammerDamageEventHandlerScript {
    run(sequence, container, handler, event) {
        const amount = Math.round(.5 * event.args.damage.amount);
        for (const allyId of container.selectLivingTargets(event.subject, Target_1.Target.AllAllies)) {
            container.applyHealing({
                sequence,
                healerId: event.subject,
                targetId: allyId,
                amount
            });
        }
    }
};
Effect_DropTheHammer_OnHammerDamageEventHandlerScript = __decorate([
    Registries_1.EventHandlerScripts.register("Effect_DropTheHammer_OnHammerDamage")
], Effect_DropTheHammer_OnHammerDamageEventHandlerScript);
exports.Effect_DropTheHammer_OnHammerDamageEventHandlerScript = Effect_DropTheHammer_OnHammerDamageEventHandlerScript;
